import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { Link } from 'react-router-dom';
import { LeftOutlined } from '@ant-design/icons';
import { getAgentId } from "app/pages/AgentPricing/modules/RefData";
import { Action } from 'app/pages/AgentPricing/actionTypes';
import './BackLink.css';

interface BackLinkProps {

}

interface StateProps {
    backUrl: string
}


interface DispatchProps {
}

type InternalProps = StateProps & DispatchProps;

function BackLink(props: InternalProps) {
    return (
        <div style={{ marginBottom: 16 }}>
            <Link to={props.backUrl} className="back-link">
                <LeftOutlined style={{ marginRight: 4 }} />
                Back to agents
            </Link>
        </div>
    );
}

function mapStateToProps(state: any, ownProps: BackLinkProps) : StateProps {
    return {
        backUrl: '/agents#' + encodeURIComponent(getAgentId(state))
    };
}

function mapDispatchToProps(dispatch: ThunkDispatch<any, any, Action>) : DispatchProps {
    return { };
}

export default connect(mapStateToProps, mapDispatchToProps)(BackLink);